module.exports = __webpack_public_path__ + "media/newstyle/images/stars_3-red-7c893a0c135f7065bf03b1b857ac0565.svg";